import * as Yup from "yup";

const SizeCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
  code: Yup.string().required("Code is required"),
});
export default SizeCreationSchema;
